import React from "react";
import { withDomains } from "../../lib/domain";
import { Button } from "antd";
import { useHistory } from "react-router-dom";

const customStyles = `
  .login-text-link {
    color: var(--Main-blue, #143E9F) !important; font-size: 12px !important; font-family: 'Inter' !important;
    font-weight: 700 !important; line-height: 18px !important; cursor: pointer !important; text-decoration: none !important;
  }
  .login-text-link:hover { text-decoration: underline !important; color: var(--Main-blue, #143E9F) !important; }
  @media (max-width: 768px) {
    .reset-link-expired-container { padding-left: 20px !important; padding-right: 20px !important; }
  }
`;

const ResetPasswordLinkExpired = () => {
  const history = useHistory();
  
  return (
    <>
      <style>{customStyles}</style>
      <div
        className="reset-link-expired-container"
        style={{
          width: '100vw',
          height: '100vh',
          paddingLeft: 280,
          paddingRight: 280,
          background: '#EEF2F7',
          overflow: 'hidden',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex'
        }}
      >
        <div
          style={{
            width: 544,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 40,
            paddingBottom: 40,
            background: '#FAFAFA',
            boxShadow: '0px 28px 62px rgba(37, 78, 207, 0.03)',
            borderRadius: 16,
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 18,
            display: 'flex'
          }}
        >
          <div style={{
            alignSelf: 'stretch',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 24,
            display: 'flex'
          }}>
            {/* <div style={{
              flex: '1 1 0',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: 2,
              display: 'flex'
            }}>
              <div style={{
                alignSelf: 'stretch',
                color: '#343C46',
                fontSize: 24,
                fontFamily: 'Inter',
                fontWeight: '700',
                wordWrap: 'break-word'
              }}>
                Link Expired
              </div>
              <div style={{
                color: '#636972',
                fontSize: 12,
                fontFamily: 'Inter',
                fontWeight: '400',
                wordWrap: 'break-word'
              }}>
                This reset password link has expired, please try again.
              </div>
            </div> */}
            <img
              src="images/tigg_logo.png"
              style={{
                width: 'auto',
                height: '56px'
              }}
              alt="Tigg Logo"
            />
          </div>

          <div style={{
            alignSelf: 'stretch',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 16,
            display: 'flex',
          }}>
            <div style={{
              alignSelf: 'stretch',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: 24,
              display: 'flex'
            }}>
              <div style={{
                alignSelf: 'stretch',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 20,
                display: 'flex',
                padding: '20px 0'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '140px',
                  height: '140px',
                }}>
                  <img 
                    src="images/error_icon.svg" 
                    alt="error" 
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                  />
                </div>
                
                {<div style={{
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 8,
                  display: 'flex',
                  textAlign: 'center'
                }}>
                  <div style={{
                    color: '#10223B',
                    fontSize: 20,
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    lineHeight: '24px',
                    wordWrap: 'break-word'
                  }}>
                    Link Expired.
                  </div>
                  <div style={{
                    color: '#636972',
                    fontSize: 14,
                    fontFamily: 'Inter',
                    fontWeight: '400',
                    lineHeight: '20px',
                    wordWrap: 'break-word',
                    maxWidth: 400
                  }}>
                    This reset password link has expired, please try again.
                  </div>
                </div>}
              </div>
            </div>

            <div style={{
              alignSelf: 'stretch',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              gap: 24,
              display: 'flex'
            }}>
              <div style={{
                alignSelf: 'stretch',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 8,
                display: 'flex'
              }}>
                <Button
                  onClick={() => history.push("/")}
                  style={{
                    alignSelf: 'stretch',
                    paddingLeft: 16,
                    paddingRight: 16,
                    paddingTop: 12,
                    paddingBottom: 12,
                    background: 'var(--Main-blue, #143E9F)',
                    boxShadow: '0px 8px 24px -8px rgba(20, 62, 159, 0.16)',
                    overflow: 'hidden',
                    borderRadius: 6,
                    border: 'none',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 8,
                    display: 'flex',
                    color: 'white',
                    fontSize: 12,
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    lineHeight: '18px',
                    cursor: 'pointer',
                    height: 'auto'
                  }}
                >
                  Go to Login
                </Button>

                {/* <div 
                  style={{
                    alignSelf: 'stretch',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    padding: '12px 16px',
                    gap: 8,
                  }}
                >
                  <span style={{
                    color: '#343C46',
                    fontSize: 12,
                    fontFamily: 'Inter',
                    fontWeight: '500',
                    lineHeight: '18px',
                    wordWrap: 'break-word'
                  }}>
                    Need a new reset link?{' '}
                  </span>
                  <span 
                    className="login-text-link"
                    onClick={() => history.push("/forgot-password")}
                  >
                    Request Password Reset
                  </span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withDomains(ResetPasswordLinkExpired, "password");
